import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesSchemesOptionRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-schemes-option',
	path: '/secure/admin/ConfigureOptionSchemes([!%]?[\\w]*).jspa',
};
